import appServices from '@/services/appServices';
import { AIRuleResponse } from '@polybank/shared/types/ai-contracts';
import { useQuery } from '@tanstack/react-query';

export function useMatchingTransactions(rawRule?: AIRuleResponse) {
  const transactionsQuery = useQuery({
    queryKey: ['matching-transactions', rawRule],
    queryFn: () => {
      return appServices.rulesApi.findMatchingTransactions(rawRule!.conditions);
    },
    enabled: !!rawRule,
  });
  return {
    count: transactionsQuery.data?.count ?? 0,
    transactions: transactionsQuery.data?.transactions ?? [],
    isLoading: transactionsQuery.isLoading,
    isError: transactionsQuery.isError,
    error: transactionsQuery.error,
  };
}
